<div class="component-wrapper g-just-flex p-20" style="flex-direction: column;">
    <!-- Insufficient Privilege Message -->
    <!-- Original form content (wrapped in permission check) -->
    @if(!data?.editMode){
    <!-- Single/Multiple Toggle (only for Laboratory requests) -->
    @if(data?.typeOfService && isLaboratoryType) {
    <mat-form-field appearance="outline" floatLabel="always"
        style="display:block; justify-content:center; margin:auto; width:max-content; padding-bottom: 20px;">
        <mat-label>
            Single or Group
        </mat-label>
        <mat-hint>
            Request a Single or Group of Lab Tests
        </mat-hint>
        <mat-select [formControl]="isMultiple">
            <mat-option value="Single">Single</mat-option>
            <mat-option value="Multiple">Group</mat-option>
        </mat-select>
    </mat-form-field>
    }

    <!-- Category and Service Request Selection Form
            - If typeOfService exists: show only after user selects Single/Group
            - If no typeOfService: always show -->
    @if(!data?.typeOfService || isChosenOption) {
    <div class="category-selection-form" style="width: 100%; max-width: 600px; margin: 0 auto 30px auto;">
        <h2 class="mat-h2">Select Service Request Type</h2>
        <p class="mat-body-1">Please select the category and specific service request you want to make.</p>

        <form [formGroup]="categoryForm" class="g-just-flex gap-20" style="flex-direction: column;">
            <!-- Category Field (hidden when typeOfService is provided) -->
            @if(!data?.typeOfService) {
            <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                <mat-label>Service Request Category</mat-label>
                <input type="text" matInput formControlName="category" [matAutocomplete]="categoryAuto"
                    placeholder="Search for a category...">
                <mat-hint>Start typing to search for categories (e.g., Laboratory, Imaging, Consultation)</mat-hint>
                @if(loadingCategories) {
                <mat-icon matSuffix>
                    <span class="spinner-border spinner-border-sm"></span>
                </mat-icon>
                }
                <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayOption">
                    @for(option of filteredCategoryOptions; track option.code) {
                    <mat-option [value]="option">
                        <strong>{{option.display}}</strong>
                        @if(option.code) {
                        <span class="text-muted"> ({{option.code}})</span>
                        }
                    </mat-option>
                    }
                    @empty {
                    <mat-option disabled>
                        No categories found. Try a different search term.
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            }

            <!-- Service Request Code Field -->
            <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                <mat-label>Service Request Code</mat-label>
                <input type="text" matInput formControlName="serviceRequestCode" [matAutocomplete]="serviceRequestAuto"
                    placeholder="Search for a service...">
                <mat-hint>Start typing to search for specific services (e.g., Blood Test, X-Ray, ECG)</mat-hint>
                @if(loadingServiceRequests) {
                <mat-icon matSuffix>
                    <span class="spinner-border spinner-border-sm"></span>
                </mat-icon>
                }
                <mat-autocomplete #serviceRequestAuto="matAutocomplete" [displayWith]="displayOption">
                    @for(option of filteredServiceRequestOptions; track option.code) {
                    <mat-option [value]="option">
                        <strong>{{option.display}}</strong>
                        @if(option.code) {
                        <span class="text-muted"> ({{option.code}})</span>
                        }
                        @if(option.active === true){
                        <!--available appp emphasis-->
                        <span [appEmphasis]="'success'" fontSize="11px">Available</span>
                        }
                    </mat-option>
                    }
                    @empty {
                    @if(!loadingServiceRequests) {
                    <mat-option disabled>
                        No service codes found. Try a different search term. But you can also enter a custom service
                        request name.
                    </mat-option>
                    }
                    }
                </mat-autocomplete>
            </mat-form-field>
        </form>

        <mat-divider style="margin: 20px 0;"></mat-divider>
    </div>
    }

    <!-- Dynamic Form -->
    <div style="position: relative; width: 100%;" [ngClass]="{'mb50': isChosenOption, 'mb-100': isMultiple.value == 'Multiple' && isChosenOption && formFields && formMetaData, 
            flexClass:true
        }">

        @if(isChosenOption && formFields && formMetaData){
        <div class="right-side">
            <app-dynamic-forms-v2 [formFields]="formFields" [formMetaData]="formMetaData"
                (formSubmitted)="processValues($event)" #cref>
            </app-dynamic-forms-v2>
        </div>
        }

        <!-- Multiple Mode: Show Resource Data Review for each item -->
        @if(isMultiple.value == 'Multiple' && isChosenOption && formFields && formMetaData){
        <form [formGroup]="requestForm" class="mt-30 left-side">
            <div formArrayName="items">
                @for(group of items.controls; track $index; ) {
                <div [formGroupName]="$index" class="one-request mb-30" [ngClass]="{'oddBg': $odd, 'evenBg': $even}">
                    <div class="request-item-header">
                        <div class="request-item-title mat-body-2">Request {{ $index + 1 }}</div>
                        <button type="button" mat-icon-button color="warn" aria-label="Remove request"
                            (click)="removeRequest($index)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <!-- {{group.value | json}} -->
                    <app-resource-data-review [resource]="group.value" [formFields]="editFormFields"
                        [submittedData]="group.value" (fieldEdited)="onFieldEdited($index, $event)"
                        (resourceUpdated)="onResourceUpdated($index, $event)" [showEditButtons]="true">
                    </app-resource-data-review>
                </div>
                @if(!$last) {
                <div class="my-5"></div>
                <mat-divider></mat-divider>
                <mat-divider></mat-divider>
                <div class="mb-10"></div>
                }
                }
            </div>
        </form>
        }

        <!-- Submit Button (shown for both Single and Multiple modes when form is valid) -->
        @if(isChosenOption && formFields && formMetaData && isMultiple.value === 'Multiple' ) {
        <div class="g-just-flex gap-30 justify-content-end mt-20 dactions flex-wrap">
            @if(isMultiple.value === 'Multiple' && requestForm && requestForm.valid && items && items.length > 0) {
            <button mat-flat-button color="primary" (click)="submitAllRequests()">
                <mat-icon>check</mat-icon>
                <span>Submit All Requests</span>
            </button>
            }
        </div>
        }
    </div>
    }@else {
    {{'hide form until category and service request are chosen'}}
    }
</div>
